import { render, staticRenderFns } from "./ScoreTableLmsSystem.vue?vue&type=template&id=343470de&scoped=true&"
import script from "./ScoreTableLmsSystem.vue?vue&type=script&lang=js&"
export * from "./ScoreTableLmsSystem.vue?vue&type=script&lang=js&"
import style0 from "./ScoreTableLmsSystem.vue?vue&type=style&index=0&id=343470de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343470de",
  null
  
)

export default component.exports